import { Check, type LucideIcon } from 'lucide-react';

import { CommandItem } from '@/components/ui/command';
import type { FilterItem } from '../model/types';

interface FilterItemProps {
  item: FilterItem;
  groupName: string;
  isSelected: boolean;
  onToggle: () => void;
  defaultIcon?: LucideIcon;
}

export function FilterItemComponent({
  item,
  groupName,
  isSelected,
  onToggle,
  defaultIcon: DefaultIcon
}: FilterItemProps) {
  return (
    <CommandItem value={`${groupName} ${item.name}`} onSelect={onToggle} className="cursor-pointer">
      {item.icon || (DefaultIcon && <DefaultIcon className="mr-2 h-4 w-4 text-muted-foreground" />)}
      <span className="flex-1">{item.name}</span>
      {isSelected && <Check className="ml-2 h-4 w-4 text-primary" />}
    </CommandItem>
  );
}
